import React, { useCallback } from 'react'
import { makeStyles, FormControl, MenuItem, Select } from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import clsx from 'clsx'
import { useIntl } from 'react-intl'

const useStyles = makeStyles({
  formControl: {
    borderRadius: '50px',
    backgroundColor: '#e5f1f7',
    boxSizing: 'content-box',
    paddingLeft: '16px',
    height: '36px',
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    '& .MuiSelect-select:focus': {
      borderRadius: 0,
      backgroundColor: 'transparent',
    },
    cursor: 'pointer',
  },
  selectedValue: {
    color: '#0073b1',
    fontFamily: 'Roboto',
    fontSize: '12px',
    lineHeight: '1.33',
    fontWeight: '500',
    width: '100%',
    '&.MuiSelect-select': {
      margin: 0,
      padding: 0,
    },
    '& > svg.MuiSvgIcon-root.MuiSelect-icon': {
      color: 'unset',
      height: '0.75em',
      width: '0.75em',
      marginTop: '3px',
    },
  },
  arrowStyle: {
    paddingRight: '34px',
    fontSize: '19px',
    cursor: 'pointer',
  },
})

const UniversalSelect = ({
  options,
  label,
  selected,
  handleSelect,
  formStyle,
  className,
}) => {
  const classes = useStyles()
  const { formatMessage } = useIntl()

  const getOption = useCallback(
    (opt) =>
      formatMessage({
        id: opt,
      }),
    [formatMessage],
  )

  return (
    <FormControl className={clsx(formStyle ? formStyle : classes.formControl)}>
      <Select
        value={selected}
        onChange={handleSelect}
        className={clsx(className ? className : classes.selectedValue)}
        disableUnderline
        IconComponent={KeyboardArrowDownIcon}
      >
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {getOption(option.label)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default React.memo(UniversalSelect)
